<script setup>
import {router, usePage} from "@inertiajs/vue3";
import Button from "primevue/button";
import {defineAsyncComponent, ref, onMounted, computed} from "vue";

const props = defineProps({
    obj: Object
})

const page = usePage();

const components = import.meta.glob('../../../administration/views/**/*.vue');

const component = defineAsyncComponent(() => {
    const pageParts = page.component?.split('/');
    const key = Object.keys(components).find(k => k.endsWith(`${pageParts[pageParts.length-1]}.vue`));
    if (key) return components[key]();
    throw new Error('Component not found: ' + page.component);
});

const isFlush = computed(() =>
    props.obj.__flags ? Object.values(props.obj.__flags).includes('flush') : false
)

const scrolled = ref(false);

let scrollContainer = null;

onMounted(() => {
    scrollContainer = document.querySelector('#neo-scroll');
    if (scrollContainer) {
        scrollContainer.addEventListener('scroll', () => {
            scrolled.value = scrollContainer.scrollTop > 10;
        });
    }
});
</script>

<template>
    <div id="neo-main" class="relative w-full">
        <!-- Flush mode: component fills full viewport, sidebar extends to top -->
        <div v-if="isFlush" class="h-dvh overflow-hidden">
            <component v-if="component" :is="component" v-bind="obj.__data" :flags="obj.__flags" :is-expanded="obj.__isExpanded"/>
        </div>

        <div v-else class="h-dvh relative flex flex-col overflow-y-auto" id="neo-scroll">
            <div :class="[
                'flex gap-4 px-6 md:px-10 items-center mb-6 top-0 z-20 transition-all duration-300',
                scrolled ? 'border-b bg-white dark:bg-black/60 dark:backdrop-blur dark:border-0 py-4 md:py-6' : 'pt-12 pb-4',
                obj.__flags ? (Object.values(obj.__flags).includes('fixed_nav_mobile') ? 'sticky w-full max-md:fixed max-md:border-b max-md:bg-white max-md:dark:bg-transparent max-md:dark:border-0 max-md:py-4 ' : 'sticky') : 'sticky'
            ]">
                <div>
                    <div class="flex items-center gap-4">
                        <i :class="obj.__icon" class="!text-2xl !md:text-3xl text-roori-blue"></i>
                        <h1 class="text-lg md:text-2xl font-bold text-gray-900 dark:text-white">{{obj.__title}}</h1>
                    </div>

                    <div v-if="obj.__description && !scrolled" class="flex items-center gap-4 -mt-1">
                        <i :class="obj.__icon" class="!text-2xl !md:text-3xl opacity-0"></i>
                        <p class="text-sm opacity-80 text-gray-700 dark:text-neutral-300">{{obj.__description}}</p>
                    </div>
                </div>
                <div class="grow"></div>
            </div>

            <div class="px-4 md:px-8 " :class="Object.values(obj.__flags).includes('fixed_nav_mobile') ? 'md:pb-8' : 'pb-8'">
                <component v-if="component" :is="component" v-bind="obj.__data" :flags="obj.__flags" :is-expanded="obj.__isExpanded"/>
            </div>
        </div>
        <div class="absolute z-30 bottom-8 right-8 max-md:bottom-2.5 max-md:right-6">
            <Button
                v-if="obj.__flags.add"
                @click="router.visit(obj.__flags.add)"
                class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 !rounded-full flex items-center gap-2"
            >
                <i class="pi pi-plus"></i> {{ $t('common.add') }}
            </Button>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
